export default {
  chooseTitle: {
    en: 'HOW TO CHOOSE YOUR {month} SCENT',
  },
  queueTitle: {
    en: 'How queue works',
  },
}
